










import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class ComponentTitle extends Vue {
  @Prop() text: string
  @Prop({ required: false }) cl: string
  @Prop({ required: true, default: 'page' }) type: string
}
